// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__fR8GW","transparent":"Overlay_transparent__ty6-8","opaque":"Overlay_opaque__tIEWe","empty":"Overlay_empty__w2kV+","loading":"Overlay_loading__JDwu4"};